<template>
  <div>
    <page-title icon="fa fa-address-book" main="Ficha Cadastral PF">
      <template v-slot:actions>
        <base-button @click="newClient()" type="neutral" class="ml-3" size="sm"
          >Cadastrar
        </base-button>
      </template>
    </page-title>
    <div class="card mt-2" style="padding: 1rem;">
      <form>
        <div class="row">
          <div class="col-md-5">
            <base-input
              label="Nome do Cliente"
              placeholder="Nome do Cliente"
              v-model="nomeClient"
            />
          </div>
          <div class="col-md-3">
            <anosafra-multiselect
              v-model="filter.anosafra"
              :options="safras"
              label="Ano Safra"
              :required="true"
              track-by="value"
              select-label=""
              deselect-label=""
              selected-label=""
              rules="required"
            />
          </div>
          <div class="col-md-2">
            <label class="form-control-label"> Status <span class="text-danger">*</span></label>
            <multiselect
              v-model="filter.status"
              :options="client_statuses"
              label="label"
              track-by="value"
              select-label=""
              deselect-label=""
              selected-label=""
              rules="required"
            />
          </div>
          <div class="col-md-2 mt-4">
            <base-button
              icon
              type="primary"
              v-on:click="getClientsWithDocumentation"
            >
              <span class="btn-inner--icon">
                <i class="fa fa-search"></i>
              </span>
              <span class="btn-inner--text">Pesquisar</span>
            </base-button>
          </div>
        </div>
      </form>
      <modal :show.sync="modals.header" id="cliente" size="lg" @save="save">
        <h2>Cabeçalho</h2>
        <span v-if="clientName"></span>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <label class="form-control-label">Safra <span class="text-danger">*</span></label><br />
            <multiselect
              v-model="safra"
              :options="safras"
              :disabled="true"
              label="descricao"
              placeholder="Selecionar Safra"
              rules="required"
            />
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <label class="form-control-label">Gerente Comercial <span class="text-danger">*</span></label><br />
            <multiselect
              v-model="manager"
              :options="managers"
              label="name"
              track-by="id"
              placeholder="Selecionar Gerente Comercial"
              rules="required"
            />
          </div>
          <div class="col-md-6 mt-4">
            <label class="form-control-label">Vendedor <span class="text-danger">*</span></label>
            <multiselect
              v-model="consultant"
              :options="salesmans"
              label="name"
              track-by="id"
              placeholder="Selecionar Vendedor"
              rules="required"
            />
          </div>
          <div class="col-md-6 mt-4">
            <label class="form-control-label">Cliente <span class="text-danger">*</span></label>
            <multiselect
              v-model="filter.clientChoosed"
              :options="clients"
              placeholder="Selecionar Clientes"
              label="razao_social"
              track-by="id"
              @search-change="setClients"
              rules="required"
            />
          </div>
        </div>
        <template slot="footer">
          <base-button type="secondary" @click="modals.header = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="modalValidation"
            >Continuar</base-button
          >
        </template>
      </modal>

      <modal :show.sync="modals.clientForm" size="xl" :mouseDownOn="false" id="cliente">
        <template slot="header">
          <div>
            <h5 class="modal-title mb-0" id="exampleModalLabel">
              Ficha cadastral
            </h5>
          </div>
        </template>
        <div>
          <wizard :loading="isSaving" @save="handleSave" @update="handleUpdate" ref="wizard">
            <div class="content">
              <wizard-tab 
                title="Ficha Cadastral Pessoa Física"
                style="margin-bottom: 10px;"
                v-show="currentPage === 0"
              >
                <validation-observer ref="form-0">
                  <div class="row" style="padding-top: 20px;">
                    <div class="col-12">
                      <label class="form-control-label">Nome <span class="text-danger">*</span></label>
                        <base-input
                          type="text"
                          :disabled="isEditing"
                          v-model="clientName"
                          rules="required"
                        />
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">Nome da Mãe <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.affiliation_mother"
                        :max="maxCharacters"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.affiliation_mother || '') }} / {{ maxCharacters }}</div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">Nome do Pai <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.affiliation_dad"
                        :max="maxCharacters"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.affiliation_dad || '') }} / {{ maxCharacters }}</div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">CPF <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.cpf"
                        mask="cpf"
                        :disabled="isEditing"
                        rules="required"
                      />
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">RG <span class="text-danger">*</span></label>
                      <base-input
                        type="tel"
                        v-model="filter.client.rg"
                        :max="maxRgLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.rg || '') }} / {{ maxRgLength }}</div>
                    </div>
                    <div class="col-12">
                      <label class="form-control-label">Endereço Residencial <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.endereco"
                        :max="maxCharacters"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.endereco || '') }} / {{ maxCharacters }}</div>
                    </div>
                    <div class="col-6">
                      <label class="form-control-label">Cidade <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.municipio"
                        :max="maxCharacterCity"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.municipio || '') }} / {{ maxCharacterCity }}</div>
                    </div>
                    <div class="col-6">
                      <label class="form-control-label">Estado <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.uf"
                        :max="maxCharacterUf"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.uf || '') }} / {{ maxCharacterUf }}</div>
                    </div>
                    <div class="col-12">
                      <label class="form-control-label">CEP <span class="text-danger">*</span></label>
                      <base-input
                        type="tel"
                        mask="cep"
                        v-model="filter.client.cep"
                        :max="maxCepLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.cep || '') }} / {{ maxCepLength }}</div>
                    </div>

                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">Email do Cliente <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.email"
                        :max="maxEmailLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.email || '') }} / {{ maxEmailLength }}</div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">Telefone <span class="text-danger">*</span></label>
                      <base-input
                        type="tel"
                        v-model="filter.client.primary_phone"
                        @keydown.backspace="onPhoneKeydown"
                        :max="maxPhoneLength"
                        :mask="backspacePressedPhone ? null : 'phone'"
                        @keyup="handleOnKeyUp"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.primary_phone || '') }} / {{ maxPhoneLength }}</div>
                    </div>
                    <div class="col-12">
                      <label class="form-control-label">Nome do Contato (Para Pagamentos) <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.contact_payment"
                        :max="maxCharacters"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.contact_payment || '') }} / {{ maxCharacters }}</div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">Telefone do Contato <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.secondary_phone"
                        :max="maxPhoneLength"
                        :mask="backspacePressedPhone ? null : 'phone'"
                        @keydown.backspace="onPhoneKeydown"
                        @keyup="handleOnKeyUp"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.secondary_phone || '') }} / {{ maxPhoneLength }}</div>
                    </div>

                    <div class="col-12 col-sm-12 col-md-6">
                      <label class="form-control-label">Nacionalidade <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.nationality"
                        :max="maxNationalityLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.nationality || '') }} / {{ maxNationalityLength }}</div>
                    </div>
                    <div class="col-12">
                      <label class="form-control-label">Data de Nascimento <span class="text-danger">*</span></label>
                      <base-input
                        rules="required"
                      >
                        <el-date-picker
                        v-model="filter.client.birthday"
                        prefix-icon="fa fa-calendar"
                        :picker-options="{ firstDayOfWeek: 1, timeZone: 'America/Sao_Paulo' }"
                        format="d 'de' MMMM 'de' yyyy"
                        :editable="false"
                        />
                    </base-input>
                    </div>
                    <div class="col-12 mt-4">
                      <label class="form-control-label">Estado Civil <span class="text-danger">*</span></label><br />
                      <multiselect
                        v-model="filter.client.marital_status"
                        :options="marital"
                        placeholder="Selecionar Estado Cívil"
                        rules="required"
                      />
                    </div>

                    <div
                      class="col-12"
                      v-if="filter.client.marital_status == 'Casado'"
                    >
                      <div>
                        <label class="form-control-label mt-4 colorButtomLabel">DADOS DO CONJUGE</label>
                      </div>

                      <label class="form-control-label">Nome <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.spouse"
                        rules="required"
                      />
                    </div>
                    <div
                      class="col-6"
                      v-if="filter.client.marital_status == 'Casado'"
                    >
                      <base-input
                        type="text"
                        label="CPF"
                        mask="cpf"
                        v-model="filter.client.spouse_cpf"
                        rules="required"
                      />
                    </div>
                    <div
                      class="col-6"
                      v-if="filter.client.marital_status == 'Casado'"
                    >
                      <label class="form-control-label">RG <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        :max="maxRgLength"
                        v-model="filter.client.spouse_rg"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(filter.client.rg || '') }} / {{ maxRgLength }}</div>
                    </div>
                    <div
                      class="col-12 mb-4"
                      v-if="filter.client.marital_status == 'Casado'"
                    >
                      <label class="form-control-label">Data de Nascimento <span class="text-danger">*</span></label>
                      <base-input
                        rules="required"
                      >
                        <el-date-picker
                        v-model="filter.client.spouse_birthday"
                        prefix-icon="fa fa-calendar"
                        format="d 'de' MMMM 'de' yyyy"
                        />
                    </base-input>
                    </div>
                  </div>
                  <div>
                    <label class="form-control-label mt-4 colorButtomLabel">Propriedade Rural</label>
                    <base-button
                      type="secundary"
                      @click="addFarm()"
                      size="sm"
                      class="ml-3 colorButtomStandart"
                      ><i class="ni ni-fat-add"></i>Adicionar Novo
                    </base-button>
                    <div
                      v-for="(farm, index) in filter.client.farms_attributes"
                      :key="farm.id"
                    >
                      <div v-if="farm._destroy !== '1'" class="row">
                        <div class="col-12" style="padding-top: 20px;">
                          <label class="form-control-label">Nome <span class="text-danger">*</span></label>
                          <base-input
                            type="text"
                            v-model="farm.farm_name"
                            rules="required"
                          />
                        </div>
                        <div class="col-6">
                          <label class="form-control-label">Endereço <span class="text-danger">*</span></label>
                          <base-input
                            type="text"
                            v-model="farm.farm_address"
                            rules="required"
                          />
                        </div>
                        <div class="col-6">
                          <label class="form-control-label">Cidade <span class="text-danger">*</span></label>
                          <base-input
                            type="text"
                            v-model="farm.farm_city"
                            rules="required"
                          />
                        </div>
                        <div class="col-6">
                          <label class="form-control-label">Estado <span class="text-danger">*</span></label>
                          <base-input
                            type="text"
                            v-model="farm.farm_state"
                            rules="required"
                          />
                        </div>
                        <div class="col-6">
                          <label class="form-control-label">CEP <span class="text-danger">*</span></label>
                          <base-input
                            mask="cep"
                            v-model="farm.farm_cep"
                            rules="required"
                          />
                        </div>
                        <div class="col-6">
                          <label class="form-control-label">Telefone <span class="text-danger">*</span></label>
                          <base-input
                            type="text"
                            v-model="farm.farms_phone"
                            @keydown.backspace="onPhoneKeydown"
                            @keyup="handleOnKeyUp"
                            rules="required"
                            />
                        </div>
                        <div class="col-6">
                          <label class="form-control-label">Inscrição Estadual <span class="text-danger">*</span></label>
                          <base-input
                            type="text"
                            v-model="farm.state_registration"
                            rules="required"
                          />
                        </div>
                        <base-button
                          outline
                          type="secundary"
                          size="sm"
                          @click="removeFarm(farm)"
                          class="ml-2 colorButtomRemove"
                          >
                            <i class="ni ni-fat-delete"></i>Remover Propriedade
                        </base-button>
                        <div class="col-md-12 mb-3 mt-3">
                          <base-button
                            type="secondary"
                            @click="toggleRegion(farm, index)"
                          >
                            Coordenadas
                          </base-button>
                        </div>
                        <div class="col-md-12">
                          <div v-if="farm.choose_location">
                            <div class="row"></div>
                          </div>
                          <div v-else>
                            <div class="row">
                              <div class="col-md-2" style="position: relative;">
                                <div style="position: absolute; top: 32%;">
                                  <base-button
                                    type="secondary"
                                    @click="toggleRegion"
                                    >Existente
                                  </base-button>
                                </div>
                              </div>
                              <div class="col-md-12">
                                <region-map
                                  :center="[
                                    farm.latitude  || -15.83,
                                    farm.longitude || -47.86,
                                  ]"
                                  :marker="marker"
                                  v-on:update:marker="setMarker"
                                  @update:marker="setMarkerFarm(farm)"
                                  :single="true"
                                />
                                <base-button
                                  type="secundary"
                                  @click="saveFarm(farm, index)"
                                  class="mt-2 colorButtomStandart"
                                  ><i class="ni ni-fat-add"></i
                                  >Salvar</base-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab 
                title="Principais Culturas"
                v-show="currentPage === 1"
              >
                <validation-observer ref="form-1">
                  <base-button
                    class="button-culture colorButtomStandart"
                    type="secundary"
                    @click="addCulture()"
                    size="sm"
                    ><i class="ni ni-fat-add"></i>Adicionar Cultura</base-button
                  >
                  <div
                    v-for="(culture, index) in filter.client.culture_ids_attributes"
                    :key="culture.id"
                    style="padding-top: 20px;"
                    v-if="!culture._destroy"
                  >
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-10">
                        <label class="form-control-label">Cultura {{ index + 1 }} <span class="text-danger">*</span></label><br />
                        <multiselect
                          :key="culture.id"
                          v-model="filter.client.culture_ids_attributes[index].selectedCulture"
                          :options="filter.cultures"
                          label="description"
                          track-by="id"
                          placeholder="Selecione cultura"
                          @search-change="getCultures"
                          @select="getCultureCicle"
                          @input="updateCultureIdCultureId(culture, $event, index)"
                          rules="required"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="validatedCultureAttributes && 
                            (!filter.client.culture_ids_attributes[index].selectedCulture || 
                              !filter.client.culture_ids_attributes[index].selectedCulture.id)
                          "
                          style="display: block;"
                        >
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-5 mt-2">
                        <label class="form-control-label">Área <span class="text-danger">*</span></label>
                        <base-input
                          type="text"
                          v-model="culture.culture_area"
                          mask="integer"
                          :max="maxAreaLength"
                          rules="required"
                        >
                          <template v-slot:error>
                            <div
                              v-if="validatedCultureAttributes && !culture.culture_area"
                              class="invalid-feedback"
                              style="display: block;"
                            >
                              Campo Obrigatório
                            </div>
                          </template>
                        </base-input>
                        <div class="character-count">{{ characterCount(String(culture.culture_area || '')) }} / {{ maxAreaLength  - 1 }}</div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-5 mt-2">
                        <base-input
                          :value="filter.client.culture_ids_attributes[index].cost_hectare"
                          @input="value => $set(filter.client.culture_ids_attributes[index], 'cost_hectare', value)"
                          label="Custo/Índice Tecnológico Padrão"
                          mask="money"
                          :disabled="true"
                        />
                      </div>
                      <div class="col-12 col-sm-12 col-md-5 mt-2">
                        <base-input
                          :value="getPotentialCulture(culture)"
                          label="Potencial de Cultura"
                          readonly
                          mask="money"
                        />
                      </div>
                      <div class="col-12 col-sm-12 col-md-5 mt-2">
                        <span>Principal</span>
                        <base-switch class="mt-3" v-model="culture.culture_main" />
                      </div>
                      <div class="col-md-2" style="position: relative;">
                        <div style="position: absolute; top: 32%;">
                          <base-button
                            type="secundary"
                            @click="removeAssociatedCulture(index)"
                            class="colorButtomRemove"
                          >
                            <i class="ni ni-fat-delete"></i>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Imóveis Rurais">
                <validation-observer ref="form-2">
                  <div class="row" style="padding-top: 20px;">
                    <div class="col-12">
                      <label class="form-control-label">Qual é o tipo de imóvel?</label>
                      <div class="row col-12">
                        <base-radio
                          name="proprietario-rural"
                          style="font-weight: 540 !important;"
                          :value="true"
                          v-model="filter.client.rural_property_attributes.rural_owner"
                          inline>Proprietário Rural</base-radio>
                        <base-radio
                          name="arrendamento"
                          style="font-weight: 540 !important;"
                          :value="false"
                          v-model="filter.client.rural_property_attributes.rural_owner"
                          inline
                          class="ml-md-4">Arrendamento</base-radio>
                      </div>
                    </div>
  
                    <div
                      class="col-12 row mt-4"
                      v-if="filter.client.rural_property_attributes.rural_owner !== 'arrendamento'"
                    >
                    <div class="col-12 col-sd-12 col-md-6">
                      <label class="form-control-label">HA Propriedade <span class="text-danger">*</span></label>
                      <base-input
                        type="number"
                        v-model="filter.client.rural_property_attributes.acre_prope"
                        rules="required"
                      />
                      </div>
                      <div class="col-12 col-sd-12 col-md-6">
                        <label class="form-control-label">Tempo Total de Propriedade <span class="text-danger">*</span></label>
                        <base-input
                          type="number"
                          mask="integer"
                          v-model="filter.client.rural_property_attributes.time_prope"
                          rules="required"
                        />
                      </div>
                    </div>
  
                    <div
                      class="col-12 row mt-4"
                      v-if="filter.client.rural_property_attributes.rural_owner === 'arrendamento'"
                    >
                      <div class="col-12 col-sd-12 col-md-6">
                        <label class="form-control-label">HA Arrendado <span class="text-danger">*</span></label>
                        <base-input
                          type="number"
                          v-model="filter.client.rural_property_attributes.acre_tenant"
                          rules="required"
                        />
                      </div>
  
                      <div class="col-12 col-sd-12 col-md-6">
                        <label class="form-control-label">Tempo Arrendamento? <span class="text-danger">*</span></label><br />
                        <base-input
                          rules="required"  
                        >
                          <el-date-picker
                            v-model="filter.client.rural_property_attributes.time_tenant"
                            prefix-icon="fa fa-calendar"
                            format="d 'de' MMMM 'de' yyyy" 
                          />
                        </base-input>
                      </div>
  
                      <div class="col-12 col-sd-12 col-md-6">
                        <label class="form-control-label">Nome Completo do Arrendatário <span class="text-danger">*</span></label>
                        <base-input
                          type="text"
                          v-model="filter.client.rural_property_attributes.name"
                          :max="maxCharacters"
                          rules="required"
                        />
                        <div class="character-count">{{ characterCount(filter.client.rural_property_attributes.name || '') }} / {{ maxCharacters }}</div>
                      </div>
  
                      <div class="col-12 col-sd-12 col-md-6">
                        <label class="form-control-label">CPF do Arrendatário <span class="text-danger">*</span></label>
                        <base-input
                          mask="cpf"
                          v-model="filter.client.rural_property_attributes.cpf"
                          :max="maxCpfLength"
                          rules="required"
                        />
                        <div class="character-count">{{ characterCount(filter.client.rural_property_attributes.cpf || '') }} / {{ maxCpfLength }}</div>
                      </div>
                    </div>
                    <div class="col-12 row">
                      <div class="col-12 col-sd-12 col-md-6">
                        <label class="form-control-label">Total HA <span class="text-danger">*</span></label>
                        <base-input
                          type="text"
                          mask="integer"
                          v-model="filter.client.rural_property_attributes.total"
                          :max="maxPhoneLength"
                          rules="required"
                        />
                        <div class="character-count">{{ characterCount(String(filter.client.rural_property_attributes.total || '')) }} / {{ maxPhoneLength }}</div>
                      </div>
                      <div class="col-12 col-sd-12 col-md-6">
                        <label class="form-control-label">Anos <span class="text-danger">*</span></label>
                        <base-input
                          type="tel"
                          v-model="filter.client.rural_property_attributes.years"
                          :max="maxYearsLength"
                          rules="required"
                        />
                        <div class="character-count">{{ characterCount(String(filter.client.rural_property_attributes.years || '')) }} / {{ maxYearsLength }}</div>
                      </div>
                      <div class="col-12 col-sd-12 col-md-6 mb-3">
                        <label class="form-control-label">Cultiva principal cultura desde qual ano? <span class="text-danger">*</span></label>
                        <base-input
                          rules="required"
                        >
                          <el-date-picker
                            v-model="filter.client.rural_property_attributes.main_culture_year"
                            prefix-icon="fa fa-calendar"
                            format="d 'de' MMMM 'de' yyyy"
                          />
                        </base-input>
                      </div>
                    </div>
                    <div
                      class="col-12 mb-3"
                      v-if="filter.client.rural_property_attributes.rural_owner === 'arrendamento'"
                    >
                      <label class="form-control-label">Contrato de Arrendamento</label>
                      <file-input :files="filter.client.rural_property_attributes.files" @update:files="addRuralPropertyFile($event, 'Contrato de Arrendamento')" multiple />
                      <file-list
                        :files="filter.client.rural_property_attributes.files"
                        @remove="
                          filter.client.rural_property_attributes.files = filter.client.rural_property_attributes.files.filter(
                            (f) => f != $event
                          )
                        "
                      />
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Negociações">
                <validation-observer ref="form-3">
                  <div class="row" style="padding-top: 20px;">
                    <div class="col-12 col-sd-12 col-md-5 mt-2">
                      <label class="form-control-label">Opera com Barter</label>
                      <base-switch
                        v-model="filter.client.rural_property_attributes.barter"
                        label="Sim"
                      />
                    </div>
  
                    <div class="col-12 col-sd-12 col-md-5 mt-2">
                      <label class="form-control-label">Contrata Seguro Rural</label>
                      <base-switch
                        v-model="filter.client.rural_property_attributes.rural_insurance"
                        label="Sim"
                      />
                    </div>
  
                    <div class="col-12 col-sd-12 col-md-10" v-if="filter.client.rural_property_attributes.rural_insurance">
                      <br />
                      <label class="form-control-label">Vencimento da Apólice <span class="text-danger">*</span></label><br />
                      <base-input
                        rules="required"
                      >
                        <el-date-picker
                          v-model="filter.client.rural_property_attributes.police_expiration"
                          prefix-icon="fa fa-calendar"
                          format="d 'de' MMMM 'de' yyyy"
                        />
                    </base-input>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Atividade Rural">
                <validation-observer ref="form-4">
                  <div class="row" style="padding-top: 20px;">
                    
                    <div class="col-12 col-sd-12 col-md-10">
                        <label class="form-control-label" style="margin-bottom: 0; font-size: 0.8125rem;">
                          EVOLUÇÃO DE ÁREA CULTIVADA NOS ÚLTIMOS TRÊS ANOS 
                          <span class="text-danger">*</span>
                        </label>
                        <multiselect
                          v-model="area_evolution"
                          :options="growths"
                          label="label"
                          trackBy="value"
                          placeholder="Selecionar Evolução da área"
                          rules="required"
                        />
                    </div>
  
                    <div class="col-12 col-sd-12 col-md-10">
                      <br />
                        <label class="form-control-label">Nível Tecnológico <span class="text-danger">*</span></label>
                        <multiselect
                          v-model="technological_level"
                          :options="levels"
                          label="label"
                          trackBy="value"
                          placeholder="Selecionar Nível Tecnológico"
                          rules="required"
                        />
                    </div>
  
                    <div class="col-12 col-sd-12 col-md-10">
                      <br />
                      <label class="form-control-label">Capac. Armazenagem <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="filter.client.rural_activity_attributes.storage_capacity"
                        append-icon="fa fa-percent"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sd-12 col-md-10">
                      <label class="form-control-label">Área Irrigada (HA) <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="filter.client.rural_activity_attributes.irrigated_area"
                        :max="maxAreaLength"
                        rules="required"
                      />
                      <div class="character-count">
                        {{ characterCount(filter.client.rural_activity_attributes.irrigated_area || '') }} / {{ maxAreaLength - 2 }}
                      </div>
                    </div>
  
                  </div>
                </validation-observer>
              </wizard-tab>


              <wizard-tab title="Criações">
                <validation-observer ref="form-5">
                  <label class="form-control-label colorButtomLabel" style="margin-bottom: 0; font-size: 0.8125rem;">
                    CRIAÇÕES (EM CABEÇAS)
                  </label>
                  <div class="row" style="padding-top: 20px;">
                    <div class="col-10">
                      <label class="form-control-label">Gado Leiteiro <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="filter.client.livestock_attributes.dairy_cattle"
                        :max="maxHeadLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(filter.client.livestock_attributes.dairy_cattle || '')) }} / {{ maxHeadLength  -3}}</div>
                    </div>
                    <div class="col-10">
                      <label class="form-control-label">Gado de Corte <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="filter.client.livestock_attributes.beef_cattle"
                        :max="maxHeadLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(filter.client.livestock_attributes.beef_cattle || '')) }} / {{ maxHeadLength  -3}}</div>
                    </div>
  
                    <div class="col-10">
                      <label class="form-control-label">Suínos <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="filter.client.livestock_attributes.swine"
                        :max="maxHeadLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(filter.client.livestock_attributes.swine || '')) }} / {{ maxHeadLength  -3}}</div>
                    </div>
                    <div class="col-10">
                      <label class="form-control-label">Caprinos <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="filter.client.livestock_attributes.goats"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(filter.client.livestock_attributes.goats || '')) }} / {{ maxHeadLength  -3}}</div>
                    </div>
  
                    <div class="col-10">
                      <label class="form-control-label">Ovinos <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="filter.client.livestock_attributes.sheep"
                        :max="maxHeadLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(filter.client.livestock_attributes.sheep || '')) }} / {{ maxHeadLength  -3}}</div>
                    </div>
  
                    <div class="col-10">
                      <label class="form-control-label">Equinos <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="filter.client.livestock_attributes.equine"
                        :max="maxHeadLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(filter.client.livestock_attributes.equine || '')) }} / {{ maxHeadLength  -3}}</div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Bens Imóveis">
                <validation-observer ref="form-6">
                  <base-button
                    class="button-imovel colorButtomStandart"
                    type="secundary"
                    @click="addImovel"
                    size="sm"
                    ><i class="ni ni-fat-add"></i>Adicionar Imovel
                  </base-button>
                  <div
                    v-for="good in filter.client.real_estates_attributes"
                    :key="good.id"
                    class="row"
                    style="padding-top: 20px;"
                  >
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Descrição (Tipo Área) <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="good.description"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Localização <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="good.address"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Valor Atual(R$) <span class="text-danger">*</span></label>
                      <money
                      v-model="good.current_value"
                      v-bind="money"
                      rules="required"
                        style="
                          height: calc(1.5em + 1.25rem + 5px);
                          width: 100%;
                          background-color: #fff;
                          background-clip: padding-box;
                          border: 1px solid #dee2e6;
                          border-radius: 0.25rem;
                        "
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Ônus/Hipoteca <span class="text-danger">*</span></label>
                      <base-input
                        type="number"
                        v-model="good.mortgage_liens"
                        rules="required"
                      />
                    </div>
                    <div class="col-md-2" style="position: relative;">
                      <div>
                        <base-button
                          type="secundary"
                          @click="removeImovel(good)"
                          class="colorButtomRemove"
                          ><i class="ni ni-fat-delete"></i
                        ></base-button>
                      </div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Bens Móveis">
                <validation-observer ref="form-7">
                  <base-button
                    class="button-imovel colorButtomStandart"
                    type="secundary"
                    @click="addVeiculo"
                    size="sm"
                    ><i class="ni ni-fat-add"></i>Adicionar Veículo
                  </base-button>
                  <div
                    v-for="vehicle in filter.client.vehicles_attributes"
                    :key="vehicle.id"
                    class="row"
                    style="padding-top: 20px;"
                  >
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Descrição/Marca <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="vehicle.brand_description"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Ano <span class="text-danger">*</span></label>
                      <base-input
                        type="number"
                        v-model="vehicle.year"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Conservação <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="vehicle.conservation"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Valor Atual(R$)<span class="text-danger">*</span></label>
                      <money
                      v-model="vehicle.current_value"
                      v-bind="money"
                      rules="required"
                        style="
                          height: calc(1.5em + 1.25rem + 5px);
                          width: 100%;
                          background-color: #fff;
                          background-clip: padding-box;
                          border: 1px solid #dee2e6;
                          border-radius: 0.25rem;
                        "
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">Ônus/Hipoteca <span class="text-danger">*</span></label>
                      <base-input
                        type="number"
                        v-model="vehicle.mortgage_liens"
                        rules="required"
                      />
                    </div>
                    <div class="col-md-2" style="position: relative;">
                      <div>
                        <base-button
                          type="secundary"
                          @click="removeVeiculo(vehicle)"
                          class="colorButtomRemove"
                        >
                          <i class="ni ni-fat-delete" />
                        </base-button>
                      </div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Referências Bancárias">
                <validation-observer ref="form-8">
                  <base-button
                    class="button-imovel colorButtomStandart"
                    type="secundary"
                    @click="addBank"
                    size="sm"
                  >
                    <i class="ni ni-fat-add" />
                    Adicionar Referência Bancária
                  </base-button>
                  <div
                    v-for="bank in filter.client.banking_references_attributes"
                    :key="bank.id"
                    class="row"
                    style="padding-top: 20px;"
                  >
                    <div class="col-10">
                      <label class="form-control-label">Cidade <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="bank.town"
                        :max="maxCharacterCity"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(bank.town || '') }} / {{ maxCharacterCity }}</div>
                    </div>
  
                    <div class="col-10">
                      <label class="form-control-label">Banco <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="bank.bank_name"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-10">
                      <label class="form-control-label">Agência <span class="text-danger">*</span></label>
                      <base-input
                        type="number"
                        v-model="bank.agency"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-10">
                      <label class="form-control-label">Telefone (DDD) <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="phone"
                        v-model="bank.phone"
                        @keydown.backspace="onPhoneKeydown"
                        @keyup="handleOnKeyUp"
                        :max="maxPhoneLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(bank.phone || '') }} / {{ maxPhoneLength }}</div>
                    </div>
  
                    <div class="col-10">
                      <label class="form-control-label">Contato <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="phone"  
                        v-model="bank.name"
                        :max="maxPhoneLength"
                        rules="required"
                        />
                      <div class="character-count">{{ characterCount(bank.name || '') }} / {{ maxPhoneLength }}</div>
                    </div>
                    <div class="col-md-2" style="position: relative;">
                      <div style="position: absolute; top: 32%;">
                        <base-button
                          type="secundary"
                          @click="removeBank(bank)"
                          class="colorButtomRemove"
                          ><i class="ni ni-fat-delete"></i
                        ></base-button>
                      </div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Pessoas Autorizadas à Receber Mercadorias">
                <validation-observer ref="form-9">
                  <base-button
                    type="secundary"
                    size="sm"
                    class="button-person colorButtomStandart"
                    @click="addAuthPerson"
                    ><i class="ni ni-fat-add"></i>Adicionar Pessoa</base-button
                  >
                  <div
                    class="row"
                    style="padding-top: 20px;"
                    v-for="contact in filter.client.contacts_attributes"
                    :key="contact.id"
                  >
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Nome <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="contact.contact_name"
                        :max="maxCharacters"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.contact_name || '') }} / {{ maxCharacters }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">CPF<span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="cpf"
                        v-model="contact.cpf"
                        :max="maxCpfLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.cpf || '') }} / {{ maxCpfLength }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">Endereço de Cobrança <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="contact.contact_address"
                        :max="maxCharacters"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.contact_address || '') }} / {{ maxCharacters }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">CEP <span class="text-danger">*</span></label>
                      <base-input
                        v-model="contact.cep"
                        mask="cep"
                        :max="maxCepLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.cep || '') }} / {{ maxCepLength }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">Cidade <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="contact.city"
                        :max="maxCharacterCity"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.city || '') }} / {{ maxCharacterCity }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">Estado <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="contact.state"
                        :max="maxCharacterUf"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.state || '') }} / {{ maxCharacterUf }}</div> 
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">Email Contato <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="contact.contact_email"
                        :max="maxEmailLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.contact_email || '') }} / {{ maxEmailLength }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Telefone do Contato (DDD) <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="phone"
                        v-model="contact.contact_phone"
                        @keydown.backspace="onPhoneKeydown"
                        @keyup="handleOnKeyUp"
                        :max="maxPhoneLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(contact.contact_phone || '') }} / {{ maxPhoneLength }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Autoriza a receber mercadoria</label>
                      <base-switch
                        v-model="contact.authorized_receive"
                        label="Sim"
                      />
                    </div>
  
                    <div class="col-md-2" style="position: relative;">
                      <div>
                        <base-button
                          type="secundary"
                          @click="removeAuthPerson(contact)"
                          class="colorButtomRemove"
                          ><i class="ni ni-fat-delete"></i
                        ></base-button>
                      </div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Referências Comerciais">
                <validation-observer ref="10">
                  <base-button
                    type="secundary"
                    size="sm"
                    class="button-person colorButtomStandart"
                    @click="addCommercials"
                    ><i class="ni ni-fat-add"></i>Adicionar
                    Referência</base-button
                  >
                  <div
                    class="row"
                    style="padding-top: 20px;"
                    v-for="commercials in filter.client
                    .commercial_references_attributes"
                    :key="commercials.id"
                  >
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">Empresa <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="commercials.company"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Contato <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="commercials.contact"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Cidade <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="commercials.town"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-10">
                      <label class="form-control-label">Telefone (DDD) <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="commercials.phone"
                        @keydown.backspace="onPhoneKeydown"
                        @keyup="handleOnKeyUp"
                        rules="required"
                      />
                    </div>
                    <div class="col-md-2" style="position: relative;">
                      <div>
                        <base-button
                          type="secundary"
                          @click="removeCommercials(commercials)"
                          class=colorButtomRemove
                          ><i class="ni ni-fat-delete"></i
                        ></base-button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="form-control-label colorButtomLabel" style="margin-bottom: 0; font-size: 0.8125rem;">
                      PARECER VENDEDOR
                    </label>
                  </div>
                  <div
                    v-for="seller_opinion in filter.client
                    .seller_opinions_attributes"
                    :key="seller_opinion.id"
                    class="row"
                    style="padding-top: 20px;"
                  >
                    <div class="col-12 col-sm-10">
                      <label class="form-control-label">Cliente Desde? <span class="text-danger">*</span></label>
                      <base-input
                        rules="required"
                      >
                        <el-date-picker
                          v-model="seller_opinion.customer_since"
                          prefix-icon="fa fa-calendar"
                          format="d 'de' MMMM 'de' yyyy"
                        />
                      </base-input>
                    </div>
                    <div class="col-12 col-sm-12 col-md-5">
                      <base-input
                        type="text"
                        label="Data e Valor da Última Compra"
                        v-model="seller_opinion.last_purchase_date"
                        :required="true"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Data e Valor da Maior Compra <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="seller_opinion.biggest_purchase_date"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Forma de Pagamento <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="seller_opinion.form_payment"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Limite de Crédito <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="seller_opinion.credit_limit"
                        :max="maxRgLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(seller_opinion.credit_limit || '')) }} / {{ maxRgLength + 1 }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Atraso Médio <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        mask="integer"
                        v-model="seller_opinion.average_delay"
                        :max="maxAreaLength"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(String(seller_opinion.average_delay || '')) }} / {{ maxAreaLength }}</div>
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Conceito <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="seller_opinion.concept"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Informante <span class="text-danger">*</span></label>
                      <base-input
                        type="text"
                        v-model="seller_opinion.informant"
                        rules="required"
                      />
                    </div>
  
                    <div class="col-12 col-sm-12 col-md-5">
                      <label class="form-control-label">Observação <span class="text-danger">*</span></label>
                      <base-input
                        type="textarea"
                        v-model="seller_opinion.comments"
                        :max="maxCharacters"
                        rules="required"
                      />
                      <div class="character-count">{{ characterCount(seller_opinion.comments || '') }} / {{ maxCharacters }}</div>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>

              <wizard-tab title="Anexos">
                <validation-observer ref="form-11">
                  <div
                    class="row"
                    v-for="(files, fileType) in groupedFiles"
                    :key="fileType"
                  >
                    <div class="col-12" style="margin-top: 15px;">
                      <label class="form-control-label colorButtomLabel" style="margin-bottom: 0; font-size: 0.8125rem;">
                        {{ translateFileType(fileType) }}
                      </label>
                    </div>
                    <div class="col-12" style="margin-top: 15px;">
                      <file-input
                        :files="files"
                        @update:files="addFile($event, fileType)"
                        multiple
                      />
                    </div>
                    <div class="col-12" style="margin-top: 15px;">
                      <file-list
                        :files="files"
                        @remove="
                          filter.client.files = filter.client.files.filter(
                            (f) => f != $event
                          )
                        "
                      />
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>
              <wizard-tab title="Parecer">
                <validation-observer ref="form-12">
                  <div class="row">
                    <div class="col-12">
                      <label class="form-control-label">Parecer do Vendedor <span class="text-danger">*</span></label>
                      <base-input
                        rules="required"
                      >
                        <textarea class="form-control" style="min-height: 180px;" type="text" v-model="filter.client.salesman_opinion" />
                      </base-input>
                    </div>
                    <div class="col-12">
                      <label class="form-control-label">Parecer do Gerente Comercial <span class="text-danger">*</span></label>
                      <base-input
                        rules="required"
                      >
                        <textarea class="form-control" style="min-height: 180px;" type="text" v-model="filter.client.manager_opinion" />
                      </base-input>
                    </div>
                  </div>
                </validation-observer>
              </wizard-tab>
            </div>
          </wizard>
        </div>
      </modal>

      <div class="border-0 card-header">
        <h3 class="mb-0">Clientes Cadastrados:</h3>
      </div>

      <el-table
        :data="documentations"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        border
        style="width: 100%;"
      >
        <el-table-column
          label="Status"
          prop="name"
          sortable
          min-width="150px"
          v-slot="{ row }"
        >
          <badge class="badge-dot mr-4" type v-if="!row.is_outdated">
            <i class="bg-success"></i> Atualizado
          </badge>
          <badge class="badge-dot mr-4" type v-else>
            <i class="bg-danger"></i> Desatualizado
          </badge>
        </el-table-column>
        <el-table-column
          label="Última Atualização"
          prop="name"
          sortable
          style="width: 40%;"
          min-width="180px"
          v-slot="{ row }"
        >
          {{
            new Date(row.updated_at).getDate() +
            "/" +
            (new Date(row.updated_at).getMonth() + 1) +
            "/" +
            new Date(row.updated_at).getFullYear()
          }}
        </el-table-column>
        <el-table-column
          label="Nome"
          prop="name"
          min-width="200px"
          sortable
          style="width: 60%;"
          v-slot="{ row }"
        >
          {{ row.name }}
        </el-table-column>

        <el-table-column
          label="Endereço"
          prop="endereco"
          min-width="200px"
          sortable
          v-slot="{ row }"
        >
          {{ row.endereco }}
        </el-table-column>

        <el-table-column
          label="Ações"
          min-width="80px"
          prop="acoes"
          v-slot="{ row }"
        >
          <el-dropdown
            trigger="hover"
            class="dropdown"
            style="cursor: pointer;"
          >
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          @input="getClientsWithDocumentation"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        />
      </div>
    </div>

    <technological-index-modal
      :show.sync="modals.technologicalIndex"
      :cicle.sync="selectedCicle"
    />
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import FileList from "@/components/FileList";
import moment from "moment";
import { Money } from "v-money";
import flatPicker from "vue-flatpickr-component";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import swal from "sweetalert2";


import Wizard from "@/components/Wizard/Wizard.vue";
import WizardTab from "@/components/Wizard/WizardTab.vue";
import "flatpickr/dist/flatpickr.css";
import RegionMap from "../Sectors/regionMap.vue";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { required } from "vee-validate/dist/rules";
import { extend, ValidationObserver } from "vee-validate";
import TechnologicalIndexModal from "@/views/Cicles/TechnologicalIndexModal";

import {
  Select,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Cascader,
  DatePicker,
} from "element-ui";


const today = new Date();
const years = today.getFullYear();

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});
export default {
  name: "app",
  components: {
    FileList,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Multiselect,
    AnosafraMultiselect,
    Wizard,
    WizardTab,
    [Cascader.name]: Cascader,
    flatPicker,
    PageTitle,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    Money,
    RegionMap,
    moment,
    TechnologicalIndexModal,
    ValidationObserver,
  },
  data() {
    return {
      validatedCultureAttributes: false,
      backspacePressedPhone: false,
      selectedCicle: {},
      technologicalIndex: {},
      active: true,
      filtered: false,
      paginated_data: {
        current: 1,
        count: 1,
        per_page: 1,
      },
      cultureId: 1,
      goodsId: 1,
      vehiclesId: 1,
      bankId: 1,
      commercialsId: 1,
      formOptions: {
        existingRegion: true,
      },
      referenceId: 1,
      authPersonId: 1,
      farmId: 1,
      searchClient: "",
      active_prop: false,
      active_barter: false,
      active_tenant: false,
      client_statuses: [
        { label: "Atualizado", value: "updated" },
        { label: "Desatualizado", value: "outdated" },
      ],
      state: null,
      state_town: "",
      growth: null,
      reduction: null,
      active_insurance: null,
      isLoadingClients: false,
      level: null,
      marital: ["Casado", "Solteiro", "Viúvo", "Divorciado"],
      growths: [
        { value: "between_zero_fifteen", label: "ENTRE 0 e 15%" },
        {
          value: "over_fifteen_justified",
          label: "CRESCIMENTO SUPERIOR A 15% JUSTIFICADO",
        },
        {
          value: "over_fifteen_unjustified",
          label: "CRESCIMENTO SUPERIOR A 15% NÃO JUSTIFICADO",
        },
        {
          value: "reduction_fifiteen_justified",
          label: "REDUÇÃO SUPERIOR A 15%JUSTIFICADO",
        },
        {
          value: "reduction_fifiteen_unjustified",
          label: "REDUÇÃO SUPERIOR A 15%NÃO JUSTIFICADO",
        },
      ],
      levels: [
        { value: "low", label: "BAIXO" },
        { value: "medium", label: "MEDIO" },
        { value: "high", label: "ALTO" },
      ],
      culture: [],
      modals: {
        header: false,
        clientForm: false,
        modal1: false,
        modal2: false,
        technologicalIndex: false,
      },
      nomeClient: "",
      safra: [],
      safras: [],
      user: {},
      selectSafra: null,
      client_email: "",
      contact_name: "",
      affiliationMother: "",
      affiliationDad: "",
      cpfClient: "",
      rgClient: "",
      addressClient: "",
      cityClient: "",
      cityContact: null,
      stateClient: "",
      cepClient: "",
      cellClient: "",
      emailClient: "",
      nameContactPaymente: "",
      contact_name_payment: "",
      cellContact: null,
      nationalityClient: "",
      birthClient: "",
      managers: [],
      manager: "",
      clients: [],
      documentations: [],
      maxCharacters: 150,
      maxCharacterCity: 50,
      maxCharacterUf: 2,
      maxCepLength:9,
      maxEmailLength: 50,
      maxPhoneLength: 15,
      maxNationalityLength: 30,
      maxRgLength: 20,
      maxAreaLength: 11,
      maxCpfLength: 14,
      maxHeadLength: 15,
      maxYearsLength: 4,
      filter: {
        anosafra: "",
        status: { label: "Atualizado", value: "updated" },
        clientChoosed: {},
        client: {
          affiliation_mother: "",
          affiliation_dad: "",
          name: "",
          contacts_attributes: [{}],
          culture_ids_attributes: [{}],
          banking_references_attributes: [{}],
          seller_opinions_attributes: [{}],
          client_properties_attributes: [{}],
          client_regions_attributes: [{}],
          cultures_attributes: [{}],
          livestock_attributes: {},
          real_estates_attributes: [{}],
          regions_attributes: [{}],
          rural_activity_attributes: [{}],
          rural_property_attributes: {
            rural_owner: false,
            tenant: "",
            acre_prope: "",
            time_prope: "",
            acre_tenant: "",
            time_tenant: "",
            name: "",
            cpf: "",
            main_culture_year: "",
            years: "",
            total: "",
            barter: "",
            rural_insurance: "",
            police_expiration: "",
            files: []
          },
          vehicles_attributes: [{}],
          commercial_references_attributes: [{}],
          farms_attributes: [
            {
              latitude: "",
              longitude: "",
            },
          ],
          manager_id: "",
          consultant_id: "",
        },
        culture: [],
        cultures: [],
        culture_cicle: [],
        culture_cicles: [],
        isLoadingCicle: false,
      },
      person: {
        name: "",
        cpf: "",
      },
      spouse: {
        name: "",
        cpf: "",
        rg: "",
        birth: null,
      },
      cultures_ids: [
        {
          name: "",
          area: "",
          cicle: "",
        },
      ],

      authPersons: [
        {
          contact_name: "",
          contact_cpf: "",
          contact_email: "",
          contact_address: "",
          contact_phone: "",
          authorized_receive: false,
        },
      ],
      farms: [
        {
          farm_name: "",
          farms_phone: "",
          farm_address: "",
          farm_cep: "",
          farm_city: "",
          farm_state: "",
          latitude: "",
          longitude: "",
        },
      ],
      look_like_salesman: "",
      consultant: "",
      salesmans: [],
      currentUser: "",
      time_tenant: "",
      acre_tenant: "",
      year_culture: "",
      years: "",
      acre_prope: "",
      time_prope: "",
      errorToUpdate: false,
      total: "",
      culture_year: "",
      main_culture_year: "",
      expirationApoli: "",
      contact_cpf: "",
      authorized_receive: false,
      storage: "",
      area: "",
      breeding: {
        dairyCattle: null,
        beefCattle: null,
        swine: null,
        goat: null,
        sheep: null,
        equine: null,
      },
      goods: [
        {
          description: "",
          address: "",
          current_value: null,
          mortgage_liens: null,
        },
      ],
      vehicles: [
        {
          brand_description: "",
          year: null,
          conservation: "",
          current_value: null,
          mortgage_liens: null,
        },
      ],
      bank: [
        {
          id: 0,
          town: "",
          bank_name: "",
          phone: null,
          name: null,
          agency: null,
        },
      ],
      commercials: [
        {
          company: "",
          contact: null,
          town: "",
          phone: "",
        },
      ],
      references: [{}],
      salesman: {
        customerSince: "",
        lastPurchase: "",
        biggestPurchase: "",
        formPayment: "",
        creditLimit: "",
        averageDelay: "",
        concept: "",
        company: "",
        informant: "",
        observation: "",
      },
      item: "",
      config: {
        altInput: false,
        allowInput: true,
        dateFormat: "d/m/Y",
        locale: Portuguese,
      },
      isSaving: false,
      fileTypes: [
        ["Cópia CPF e RG", "rg"],
        ["Cópia do último Imposto de Renda", "imposto de renda"],
        [
          "Cópia do contrato de Áreas arrendada (caso houver)",
          "contrato de áreas arrendadas",
        ],
        [
          "Apólice do seguro agrícola (caso houver)",
          "apolice do seguro agrícola",
        ],
        ["Certidão de Matrícula", "certidão de matrícula"],
        ["Carteira de Inscrição Estadual", "carteira de inscrição estadual"],
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      filteredRegions: [],
      marker: {},
      sliderValue: 4500,
      client_types: [],
      client_sizes: [],
    };
  },
  mounted() {
    this.currentUser = this.$currentUser();
    this.limpCampos();
    this.filter.client.birthday = '1900-01-01'

    this.openModalWithClient();
    this.getClientsWithDocumentation();
    this.loadSafra();
    this.setClients();

    if (this.$can("index", "user")) {
      this.getSalesmens();
    }

    if (this.currentUser.is_admin) {
      this.loadManagers();
    } else if (
      this.currentUser.is_manager ||
      this.currentUser.has_coordinateds
    ) {
      this.managers = [this.currentUser];
      this.salesmans = this.currentUser.salesmans;
      this.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.managers = [this.currentUser.manager];
      this.salesmans = [this.currentUser];
      this.manager = this.currentUser.manager;
      this.consultant = this.currentUser;
    }
    this.getCultures();
    this.getCultureCicle();
  },
  methods: {
    async removeAssociatedCulture(index) {
      const fireResult = await swal.fire({
        title: 'Você tem certeza ?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Tenho Certeza!'
      })

      if (!fireResult.isConfirmed) {
        return
      }

      const item = this.filter.client.culture_ids_attributes[index];

      if (item.id) {
        this.$set(item, '_destroy', true)
      } else {
        this.filter.client.culture_ids_attributes.splice(index, 1)
      }
    },
    getPotentialCulture(culture) {
      if (!culture) {
        return 0;
      }
      if (typeof culture.culture_area === 'undefined' || typeof culture.cost_hectare === 'undefined') {
        return 0;
      }
      const valueCulture = parseFloat(culture.culture_area);
      const valueArea = parseFloat(culture.cost_hectare);

      if (isNaN(valueCulture) || isNaN(valueArea)) {
        return 0;
      }

      const resultado = valueCulture * valueArea;
      return resultado;
    },
  async initCicles(culture) {
    try {
      const anosafraId = this.$store.state.currentAnosafra.id;
      const cultureId = culture.id;

      const response = await this.$http.secured
        .get('/api/v1/cicles', {
          params: {
            anosafra_id: anosafraId,
            culture_id: cultureId
          }
        })
      return response.data
    } catch (error) {
      console.error('Erro ao inicializar os ciclos:', error);
    } finally {}
  },
  updateCultureIdCultureId(culture, $event, index) {
      if (!$event) return;
      
      this.populateTechnogicalIndex($event, index);
      this.$set(this.filter.client.culture_ids_attributes, index, {
        ...culture,
        culture_id: $event.id,
        culture_name: $event.description,
        selectedCulture: $event
      });
    },
    async populateTechnogicalIndex(cultureIdAttribute, index) {
      const cicles = await this.initCicles(cultureIdAttribute);
      let totalTechnologicalIndex = 0

      if (cicles)  {
        totalTechnologicalIndex   = cicles.reduce((sum, cicle) => sum + cicle.technological_index, 0);
      }

      cultureIdAttribute.cost_hectare = totalTechnologicalIndex;
      this.$set(this.filter.client.culture_ids_attributes[index], 'cost_hectare', totalTechnologicalIndex);
    },
    setCultureNames() {
      this.filter.client.culture_ids_attributes.forEach((cultureAttr, index) => {
        const culture = this.filter.cultures.find(c => c.id === cultureAttr.culture_id);

        if (!culture) return;

        this.populateTechnogicalIndex(culture, index);
        this.$set(this.filter.client.culture_ids_attributes[index], 'selectedCulture', culture);
      });
    },
    onPhoneKeydown(e) {
      if (e.keyCode === 8) {
        return this.backspacePressedPhone = true;
      }
    },
    handleOnKeyUp(e) {
      if (e.keyCode != 8) this.backspacePressedPhone = false;
    },
      setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    characterCount(text) {
      return text ? text.length : 0;
    },
    async validate() {
      const currentObserverRef = `form-${this.$refs.wizard.activeStep}`;
      const currentObserver = this.$refs[currentObserverRef];

      try {
        const isValid = await currentObserver.validate();
        
        if (isValid) {
          this.save();
        } else {
          console.error('Erro ao salvar: Validação falhou.');
          this.$toasted.global.defaultError({ msg: "Validação dos campos falhou.", })
        }
      } catch (error) {
        console.error('Erro ao validar:', error);
        this.$toasted.global.defaultError({ msg: "Erro ao validar os campos.", })

      }
    },
    async handleSave() {
      await this.validate();
    },
    async save() {
      if (this.filter.client.id) {
        await this.updateClient();
      } else {
          await this.createClient();
      }
    },
    async handleUpdate() {
      if (this.filter.client.id) {
        await this.updateAdd()
      }
    },
    async createClient() {
      this.isSaving = true;
      try {
        await this.$http.secured.post(`/api/v1/clients`, this.formData);
        this.getClientsWithDocumentation();
        this.limpCampos();
        this.modals.clientForm = false;
      } catch (error) {
        if (
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors[0]
        ) {
          this.$toasted.global.defaultError({
            msg: error.response.data.errors[0],
          });
        }
        this.$toasted.global.defaultError({
          msg: "Não foi possivel cadastrar a ficha!",
        });
        console.log(error);
        this.setError(error, "Something went wrong");
      }

      this.isSaving = false;
    },
    limpCampos() {
      if (!this.filter) this.filter = {};

      this.filter.client = {
        affiliation_mother: "",
        affiliation_dad: "",
        name: "",
        contacts_attributes: [{}],
        culture_ids: [{}],
        banking_references_attributes: [{}],
        seller_opinions_attributes: [{}],
        client_properties: [{}],
        client_regions: [{}],
        cultures: [{}],
        livestock_attributes: {},
        real_estates_attributes: [{}],
        regions: [{}],
        rural_activity_attributes: [{}],
        rural_property_attributes: {
          rural_owner: false,
          tenant: "",
          acre_prope: "",
          time_prope: "",
          acre_tenant: "",
          time_tenant: "",
          name: "",
          cpf: "",
          main_culture_year: "",
          years: "",
          total: "",
          barter: "",
          rural_insurance: "",
          police_expiration: "",
          files: [],
        },
        farms: [
          {
            farm_name: "",
            farms_phone: "",
            farm_address: "",
            farm_cep: "",
            farm_city: "",
            farm_state: "",
            latitude: "",
            longitude: "",
          },
        ],
        farms_attributes: [
          {
            farm_name: "",
            farms_phone: "",
            farm_address: "",
            farm_cep: "",
            farm_city: "",
            farm_state: "",
            latitude: "",
            longitude: "",
          },
        ],
        vehicles_attributes: [{}],
        commercial_references_attributes: [{}],
        files: [],
        consultant_id: "",
        manager_id: "",
      };

      this.filter = Object.assign({}, this.filter);

      this.consultant = "";
      this.manager = "";
    },
    newClient() {
      this.limpCampos();
      this.modals.header = true;
    },
    edit(client) {
      this.limpCampos();
      this.openModalWithClient(client);
      this.setCultureNames();
    },
    async getCurrentAnosafraClientRegion(client) {
      const currentAnosafra = this.$store.state.currentAnosafra;

      try {
        const response = await this.$http.secured.get("/api/v1/regions", {
          params: { q: { client_id: client.id, anosafra_id: currentAnosafra.id } },
        });

        return response.data[0]
        
      } catch (error) {
        console.log("[getCurrentAnosafraClientRegion]: ", error)
      }

    },
    updateCulture(clientRegion = null) {
      const region = this.$route.params.region || clientRegion

      if (
        region &&
        region.id &&
        this.filter.client.culture_ids_attributes
      )
        this.filter.client.culture_ids_attributes.forEach(
          (culture) => (culture.region_id = region.id)
        );
      else if (
        this.consultant &&
        this.consultant.region &&
        this.filter.client.culture_ids_attributes
      )
        this.filter.client.culture_ids_attributes.forEach(
          (culture) => (culture.region_id = this.consultant.region.id)
        );
      else if (
        this.$currentUser().region &&
        this.$currentUser().region.id &&
        this.filter.client.culture_ids_attributes
      )
        this.filter.client.culture_ids_attributes.forEach(
          (culture) => (culture.region_id = this.$currentUser().region.id)
        );
      else {
        this.errorToUpdate = true;
        this.$toasted.global.defaultError({
          msg:
            " Para criação ou atualização de culturas, é preciso utilizar um usuário que possui região. ",
        });
      }
    },
    validateCultureAttributes() {
      this.validatedCultureAttributes = false
      const invalidCultures = this.filter.client.culture_ids_attributes.some(
        (cultureId) => {
          return !cultureId.selectedCulture || !cultureId.culture_area        
        }
      )

      this.validatedCultureAttributes = true

      return !invalidCultures;
    },
    updateSellerOpinion(clientRegion = null) {
      const region = this.$route.params.region || clientRegion
      
      if (
        region &&
        region.id &&
        this.filter.client.seller_opinions_attributes
      ) {
        // pego da rota de carteira de clientes
        this.filter.client.seller_opinions_attributes[0].region_id = region.id;
        this.consultant_id = region.id;
      } else if (
        this.consultant &&
        this.consultant.region &&
        this.filter.client.seller_opinions_attributes
      ) {
        // esse aqui da modal pegando o vendedor
        this.filter.client.seller_opinions_attributes[0].region_id = this.consultant.region.id;
      } else if (
        this.$currentUser().region &&
        this.$currentUser().region.id &&
        this.filter.client.seller_opinions_attributes
      )
        this.filter.client.seller_opinions_attributes[0].region_id = this.$currentUser().region.id;
      else {
        this.errorToUpdate = true;
        this.$toasted.global.defaultError({
          msg:
            " Para criação de parecer ou atualização, é preciso utilizar um usuário que possui região. ",
        });
      }
    },
    async updateRegionData() {
      const clientRegion = await this.getCurrentAnosafraClientRegion(this.filter.client)
      this.updateSellerOpinion(clientRegion);
      this.updateCulture(clientRegion);
    },
    async updateClient() {
      this.filter.client.documentation = true;
      const validCultures = this.validateCultureAttributes();

      if (!validCultures) {
        this.$refs.wizard.setActive(1)
        return;
      }

      await this.updateRegionData()

      this.isSaving = true;

      if (!this.errorToUpdate) {
        try {
          await this.$http.secured.put(
            `/api/v1/clients/${this.filter.client.id}`,
            this.formData
          );
          this.getClientsWithDocumentation();
          this.limpCampos();
          this.modals.clientForm = false;
        } catch (error) {
          this.setError(error, "Cannot delete client");
        }
        this.isSaving = false;
      }
    },
    async updateAdd() {
      this.filter.client.documentation = true;
      await this.updateRegionData()
      const validCultures = this.validateCultureAttributes();

      if (!validCultures) return;

      this.isSaving = true;

      if (!this.errorToUpdate) {
        try {
          await this.$http.secured.put(
            `/api/v1/clients/${this.filter.client.id}`,
            this.formData
          );
          this.getClientsWithDocumentation();
        } catch (error) {
          this.setError(error, "Cannot delete client");
        }
        this.isSaving = false;
      }
    },
    formatDate(dateString) {
      let dateParts = dateString.split(" / ");
      return finalString;
    },
    async getClientsWithDocumentation(q = "") {
      const data = {
        per_page: 10,
        page: this.paginated_data.current,
        q: { cpf: 15, documentation: true },
      };

      if (!this.$currentUser().is_admin) {
        data.q.user_ids = this.$currentUser().id;
      }

      if (this.nomeClient) data.q.name = this.nomeClient;
      if (this.filter.year) data.q.year = this.filter.year;
      if (this.filter.status) data.q.status = this.filter.status.value;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q.anosafra_ids = this.filter.anosafra.id;

      const response = await this.$http.secured.get("/api/v1/clients", {
        params: data,
      });
      this.paginated_data = response.data;
      this.documentations = response.data.clients;
    },
    openModalWithClient(client = null) {
      const selectedClient =  client || this.$route.params.client
      
      if (!selectedClient) return;

      this.modals.clientForm = true;
      this.filter.clientChoosed = selectedClient;
      this.filter.clientChoosed.birthday = moment(selectedClient.birthday).add(1, 'days').format('YYYY-MM-DD')
      this.filter.clientChoosed.lastCultureIds = selectedClient.culture_ids
      this.filter.clientChoosed.culture_ids_attributes = []
      this.filter.clientChoosed.culture_ids = this.filter.clientChoosed.culture_ids.map((culture) => {
        return {
          id: culture.id,
          description: culture.culture_name,
          culture_area: culture.culture_area,
          client_property_id: culture.client_property_id,
          culture_id: culture.culture_id,
          cost_hectare: culture.cost_hectare,
        }
      })

      this.modalValidation();
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      this.setData(filterInput, page);
    },
    search() {
      this.filtered = !this.emptyFilter;
      this.setData(this.normalizedFilter);
    },
    moment: function () {
      return moment();
    },
    setData(q, page) {
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;
      this.$http.secured
        .get(`/api/v1/clients`, {
          params: {
            clients_id: this.$route.params.clients_id,
            page: page,
            q: {
              ...q,
            },
          },
        })
        .then((response) => {
          this.paginated_data = response.data;
          this.clients = this.paginated_data["clients"];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    setClients(q = "") {
      const data = {
        per_page: 10,
        page: 1,
        grouped_by_region: true,
        q: { razao_social: q, cpf: 15 },
      };
      if (!this.$currentUser().is_admin && this.$currentUser().is_salesman) {
        data.q.manager_ids = this.$currentUser().manager.id;
        data.q.user_ids = this.$currentUser().id;
      }
      if (this.$currentUser().is_manager)
        data.q.manager_id = this.$currentUser().id;
      if (this.safra && this.safra.id) data.q.anosafra_ids = this.safra.id;
      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          this.clients = response.data["clients"][0].clients;
        })
        .catch((error) => this.setError(error, "failed to fetch clients"));
    },
    addCommercials() {
      if (!this.filter.client.commercial_references_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          commercial_references_attributes: [],
        });
      }
      this.filter.client.commercial_references_attributes.push({
        company: "",
        contact: "",
        town: "",
        phone: ""
      });
    },
    removeCommercials(bank) {
      this.filter.client.commercial_references_attributes = this.filter.client.commercial_references_attributes.filter(
        (b) => b != bank
      );
      if (bank.id != null) {
        this.filter.client.commercial_references_attributes.push({
          id: bank.id,
          _destroy: "1",
        });
      }
    },
    addBank() {
      if (!this.filter.client.banking_references_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          banking_references_attributes: [],
        });
      }
      this.filter.client.banking_references_attributes.push({
        town: "",
        bank_name: "",
        phone: "",
        name: "",
        agency: null
      });
    },
    removeBank(bank) {
      this.filter.client.banking_references_attributes = this.filter.client.banking_references_attributes.filter(
        (b) => b != bank
      );
      if (bank.id != null) {
        this.filter.client.banking_references_attributes.push({
          id: bank.id,
          _destroy: "1",
        });
      }
    },
    addOpinion() {
      if (!this.filter.client.seller_opinions_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          seller_opinions_attributes: [],
        });
      }
      this.filter.client.seller_opinions_attributes.push({
        customer_since: "",
        last_purchase_date: "",
        biggest_purchase_date: "",
        form_payment: "",
        credit_limit: "",
        average_delay: "",
        concept: "",
        company: "",
        informant: "",
        comments: "",
        region_id: ""
      });
    },
    removeOpinion(opinion) {
      this.filter.client.seller_opinions_attributes = this.filter.client.seller_opinions_attributes.filter(
        (op) => op != opinion
      );
      if (opinion.id != null) {
        this.filter.client.seller_opinions_attributes.push({
          id: opinion.id,
          _destroy: "1",
        });
      }
    },
    addVeiculo() {
      if (!this.filter.client.vehicles_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          vehicles_attributes: [],
        });
      }
      this.filter.client.vehicles_attributes.push({
        brand_description: "",
        year: null,
        conservation: "",
        current_value: null,
        mortgage_liens: null
      });
    },
    removeVeiculo(vehicle) {
      this.filter.client.vehicles_attributes = this.filter.client.vehicles_attributes.filter(
        (v) => v != vehicle
      );
      if (vehicle.id != null) {
        this.filter.client.vehicles_attributes.push({
          id: vehicle.id,
          _destroy: "1",
        });
      }
    },
    addImovel() {
      if (!this.filter.client.real_estates_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          real_estates_attributes: [],
        });
      }
      this.filter.client.real_estates_attributes.push({
        description: "",
        address: "",
        current_value: null,
        mortgage_liens: null
      });
    },
    removeImovel(real_estate) {
      this.filter.client.real_estates_attributes = this.filter.client.real_estates_attributes.filter(
        (r) => r != real_estate
      );
      if (real_estate.id != null) {
        this.filter.client.real_estates_attributes.push({
          id: real_estate.id,
          _destroy: "1",
        });
      }
    },
    toggleRegion(farm, index) {
      if (!(this.filter && this.filter.client)) return;
      if (
        !(
          this.filter.client.farms_attributes &&
          this.filter.client.farms_attributes.length
        )
      ) {
        this.filter.client.farms_attributes = [
          {
            farm_name: "",
            farms_phone: "",
            farm_address: "",
            farm_cep: "",
            farm_city: "",
            farm_state: "",
            latitude: "",
            longitude: "",
          },
        ];
      }

      this.marker = {
        coordinates: [farm.latitude || "", farm.longitude || ""],
      };

      this.filter.client.farms_attributes.forEach((farm) => {
        farm.choose_location = true;
      });
      this.filter.client.farms_attributes[index].choose_location = false;

      this.filter = Object.assign({}, this.filter);
    },
    toggleBranch() {
      this.formOptions.existingBranch = !this.formOptions.existingBranch;
      if (!this.formOptions.existingBranch) {
        this.filteredRegions = this.regions;
      } else {
        this.filteredRegions = this.filterRegions(this.branch.id);
      }
    },
    addCulture() {
      if (!this.filter.client.culture_ids_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          culture_ids_attributes: [],
        });
      }
      this.filter.client.culture_ids_attributes.push({
        client_id: this.cultureId,
        culture_name: "",
        cicle_id: "",
        culture_area: null,
        cost_hectare: null,
        culture_main: false
      });
    },
    getCultures() {
      this.$http.secured
        .get("/api/v1/cultures", {
          params: {
            unpaged: true,
          },
        })
        .then((response) => {
          this.filter.cultures = response.data;
          this.setCultureNames();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    async getCultureCicle(value) {
      if (!(this.filter && this.filter.cultures)) return;

      const culture = this.filter.cultures.find((x) => x.description == value);

      this.filter.isLoadingCicle = true;

      try {
        const response = await this.$http.secured.get(
          `/api/v1/cultures/${culture && culture.id}/cicles`
        );
        this.filter.culture_cicles = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.filter.isLoadingCicle = false;
      }
    },
    addAuthPerson() {
      if (!this.filter.client.contacts_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          contacts_attributes: [],
        });
      }
      this.filter.client.contacts_attributes.push({
        contact_name: "",
        contact_cpf: "",
        contact_email: "",
        contact_address: "",
        contact_phone: "",
        authorized_receive: false,
        selectedCulture: {},
      });
    },
    removeAuthPerson(contact) {
      this.filter.client.contacts_attributes = this.filter.client.contacts_attributes.filter(
        (c) => c != contact
      );
      if (contact.id != null) {
        this.filter.client.contacts_attributes.push({
          id: contact.id,
          _destroy: "1",
        });
      }
    },
    addFarm() {
      if (!this.filter.client.farms_attributes) {
        this.filter.client = Object.assign({}, this.filter.client, {
          farms_attributes: [],
        });
      }

      this.addMapOptionFarms();

      this.filter.client.farms_attributes.push({
        farm_name: "",
        farm_address: "",
        farms_phone: "",
        farm_cep: "",
        farm_city: "",
        farm_state: "",
        latitude: "",
        longitude: "",
        choose_location: false
      });
    },
    removeFarm(farm) {
      this.filter.client.farms_attributes = this.filter.client.farms_attributes.filter(
        (f) => f != farm
      );
      if (farm.id != null) {
        this.filter.client.farms_attributes.push({
          id: farm.id,
          _destroy: "1",
        });
      }
    },
    saveFarm(farm, index) {
      Vue.set(
        this.filter.client.farms[index],
        "choose_location",
        !farm.choose_location
      );

      this.$toasted.global.defaultSuccess({
        msg: "Sucesso!",
      });
      this.marker = {};
    },
    modalValidation() {
      this.filter.client = this.filter.clientChoosed;
      this.modals.header = false;

      this.filter.client = Object.assign({}, this.filter.clientChoosed, {
        contacts_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.contacts) || [{}],
        culture_ids_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.culture_ids) || [{}],
        banking_references_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.banking_references) || [{}],
        seller_opinions_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.seller_opinions) || [{}],
        client_properties_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.client_properties) || [{}],
        client_regions_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.client_regions) || [{}],
        cultures_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.cultures) || [{}],
        farms_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.farms) || [{}],
        livestock_attributes:
          (this.filter &&
            this.filter.clientChoosed &&
            this.filter.clientChoosed.livestock) ||
          {},
        real_estates_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.real_estates) || [{}],
        regions_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.regions) || [{}],
        rural_activity_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.rural_activity) || [{}],
        rural_property_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.rural_property) || {
          rural_owner: false,
        },
        vehicles_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.vehicles) || [{}],
        commercial_references_attributes: (this.filter &&
          this.filter.clientChoosed &&
          this.filter.clientChoosed.commercial_references) || [{}],
        files: [],
      });
      this.addMapOptionFarms();

      this.modals.clientForm = true;
    },
    addMapOptionFarms() {
      this.filter.client.farms_attributes.forEach((farm) => {
        farm.choose_location = true;
      });
    },
    modalValidationEdit() {
      this.modals.modal1 = false;
      this.modals.modal2 = true;
    },
    loadSafra() {
      this.$http.secured
        .get("/api/v1/anosafras", { params: { unpaged: true } })
        .then((response) => {
          this.safras = response.data;
          this.safra = this.$store.state.currentAnosafra;

          if (
            !(this.safra && Object.keys(this.safra).length)
          ) {
            this.safra = this.safras[0];
          }
        });
    },
    loadManagers() {
      var data = {
        per_page: 10,
        q: {
          is_manager: true,
          anosafra_id: this.safra.id,
          status: this.active,
        },
      };
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.managers = response.data.users || [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getSalesmens() {
      var data = {
        q: {
          is_salesman: true,
          manager_id: this.manager.id,
          anosafra_id: this.safra.id,
          status: this.active,
        },
      };
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.salesmans = response.data.users || [];
        });
    },
    setMarker(value) {
      this.marker = value;
    },
    setMarkerFarm(farm) {
      if (Object.keys(this.marker).length) {
        farm.latitude = this.marker.coordinates[0];
        farm.longitude = this.marker.coordinates[1];
      }
    },
    addFile(files, fileType) {
      const renamedFiles = [];
      for (const file of files) {
        renamedFiles.push(this.renameFile(file, `${fileType} - ${file.name}`));
      }
      this.filter.client = Object.assign({}, this.filter.client, {
        files: [...this.filter.client.files, ...[...renamedFiles]],
      });
    },
    addRuralPropertyFile(files, fileType) {
      const renamedFiles = [];
      for (const file of files) {
        renamedFiles.push(this.renameFile(file, `${fileType} - ${file.name}`));
      }
      console.debug('renamedFiles:', renamedFiles)
      this.filter.client.rural_property_attributes = Object.assign({}, this.filter.client.rural_property_attributes, {
        files: [...(this.filter.client.rural_property_attributes.files || []), ...[...renamedFiles]],
      });
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
    translateFileType(fileType) {
      const type = this.fileTypes.find((t) => t[1] == fileType);
      return (type && type[0]) || "Outros";
    },
  },
  computed: {
    isEditing() {
      return this.filter.client ? true : false;
    },
    formData() {
      return this.$buildFormData(this.filter.client, "cliente");
    },
    groupedFiles() {
      if (!(this.filter.client && this.filter.client.files)) return {};
      const response = {};

      this.fileTypes.forEach((type) => {
        response[type[1]] = this.filter.client.files.filter((f) =>
          f.name.match(`${type[1]} - `)
        );
      });
      response.outros = this.filter.client.files.filter(
        (f) => !Object.values(response).flat().includes(f)
      );
      return response;
    },
    area_evolution: {
      get() {
        return this.growths.find(
          (g) =>
            g.value ==
            this.filter.client.rural_activity_attributes.area_evolution
        );
      },
      set(val) {
        this.filter.client.rural_activity_attributes = Object.assign(
          {},
          this.filter.client.rural_activity_attributes,
          {
            area_evolution: val.value,
          }
        );
      },
    },
    technological_level: {
      get() {
        return this.levels.find(
          (l) =>
            l.value ==
            this.filter.client.rural_activity_attributes.technological_level
        );
      },
      set(val) {
        this.filter.client.rural_activity_attributes = Object.assign(
          {},
          this.filter.client.rural_activity_attributes,
          {
            technological_level: val.value,
          }
        );
      },
    },
    reqParams: function () {
      if (this.clients.hasOwnProperty("id")) {
        return {
          url: `/api/v1/clients/${this.clients.id}`,
          method: "patch",
          data: {
            ...this.clients,
          },
        };
      }
      return {
        url: "/api/v1/clients",
        method: "post",
        data: {
          ...this.clients,
        },
      };
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    normalizedFilter: function () {
      const filter = Object.assign({}, this.filter);
      for (let key in filter) {
        if (filter.hasOwnProperty(key) && typeof filter[key] == "object") {
          if (filter[key].hasOwnProperty("id")) {
            filter[key + "_id"] = filter[key].id;
            delete filter[key];
          } else {
            filter[key] = filter[key].value;
          }
        }
        if (filter[key] == "") {
          delete filter[key];
        }
      }

      return filter;
    },
    clientName: {
      get() {
        return (
          (this.filter &&
            this.filter.client &&
            (this.filter.client.name || this.filter.client.razao_social)) ||
          ""
        );
      },
      set(name) {
        this.filter.client.name = name;
        this.filter.client.razao_social = name;
      },
    },
  },
  watch: {
    consultant(val) {
      this.filter.client.consultant_id = val && val.id;
      this.setClients();
    },
    manager(val) {
      if (val) this.filter.client.manager_id = val.id;
      
      this.getSalesmens();
    },
    safra() {
      if (this.currentUser.is_admin) this.loadManagers();
    },
    "filter.client.culture_ids_attributes": {
      handler: function (_before, after) {
        if (!after) return;
        if (
          !(
            this.filter &&
            this.filter.client &&
            this.filter.client.culture_ids_attributes
          )
        )
          return;

        this.filter.client.culture_ids_attributes.forEach((culture) => {
          if (culture && culture.cicle && culture.cicle.id) {
            culture.cicle_id = culture.cicle.id;
          }
        });
      },
      deep: true,
    },
  },

};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.cascader {
  width: 360px;
}

.multiselect__tags {
  font-size: 10px !important;
}

.multiselect__single {
  font-size: 11px !important;
}

.character-count {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 26px;
  margin-right: 23px;
  color: #555;
  font-size: 10px;
}

.colorButtomStandart{
 color: #2dce89
}

.colorButtomLabel{
 color: #8898aa;
}

.colorButtomRemove{
  color:#f5365c
}
</style>
